/**
 * @file Database-driven targeting detection for deploy effects
 * @module targeting/needsTargetingOnDeploy
 */

/**
 * Check if an order needs targeting on deployment based on database rules
 * @param {Object} order - The order to check
 * @param {Object} targetingData - Database targeting data
 * @returns {boolean} True if the order needs targeting on deployment
 */
function needsTargetingOnDeploy(order, targetingData) {
  if (!order || !order.id) return false;
  if (!targetingData?.deployUnits) return false;
  
  // Find targeting rules for this unit
  const deployRule = targetingData.deployUnits.find(rule => rule.id === order.id);
  
  // Return true if targeting is required and not 'none'
  return deployRule && deployRule.targeting !== 'none';
}

export default needsTargetingOnDeploy;
